import React from 'react';
import styles from './style.module.scss';

type Props = {
  size?: number; // SVG width/height in px
  strokeWidth?: number;
};

const LineDash: React.FC<Props> = ({ size = 10, strokeWidth = 1.5 }) => (
  <div className={`${styles.iconComponent} size${size}`} aria-hidden>
    {/* viewBox kept small so component matches your existing CircleIcon sizing */}
    <svg width={size * 2} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* A single horizontal line with dash pattern to produce three dashes. */}
      <line x1="1" y1="5" x2="20" y2="5" strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray="3 3 3" />
    </svg>
  </div>
);
export default LineDash;
